export const MappingIPA = {
  aa: "ɑ",
  ae: "æ",
  ah: "ə",
  ah0: "ə",
  ah1: "ʌ",
  ao: "ɔ",
  aw: "aʊ",
  ay: "aɪ",
  b: "b",
  ch: "tʃ",
  d: "d",
  dh: "ð",
  eh: "ɛ",
  er: "ɜ",
  ey: "eɪ",
  f: "f",
  g: "g",
  hh: "h",
  ih: "ɪ",
  iy: "i",
  jh: "dʒ",
  k: "k",
  l: "l",
  m: "m",
  n: "n",
  ng: "ŋ",
  ow: "oʊ",
  oy: "ɔɪ",
  p: "p",
  r: "r",
  s: "s",
  sh: "ʃ",
  t: "t",
  th: "θ",
  uh: "ʊ",
  uw: "u",
  v: "v",
  w: "w",
  y: "j",
  z: "z",
  zh: "ʒ",
  sil: "Silence",
  spn: "Spoken noise",
};
